import { PenLine } from 'lucide-react'

interface GenerationCardProps {
  streamBuffer: string
}

function countWords(text: string): number {
  if (!text.trim()) return 0
  return text.trim().split(/\s+/).length
}

export function GenerationCard({ streamBuffer }: GenerationCardProps) {
  const wordCount = countWords(streamBuffer)
  const isEmpty = streamBuffer.length === 0

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <div className="flex items-center justify-center w-5 h-5 rounded-md bg-violet-50 text-violet-600">
            <PenLine className="w-3 h-3" />
          </div>
          <span className="text-xs font-semibold text-slate-500">
            {isEmpty ? 'Esperando contenido...' : 'Generando...'}
          </span>
        </div>
        {wordCount > 0 && (
          <span className="text-xs text-violet-600 font-medium bg-violet-50 px-2 py-0.5 rounded-full">
            {wordCount} {wordCount === 1 ? 'palabra' : 'palabras'}
          </span>
        )}
      </div>

      <div className="min-h-[5rem] max-h-64 overflow-y-auto rounded-lg bg-slate-50 border border-slate-100 px-3 py-2.5 text-xs text-slate-700 leading-relaxed whitespace-pre-wrap break-words">
        {isEmpty ? (
          <span className="text-slate-400 italic">El contenido aparecera aqui...</span>
        ) : (
          <>
            {streamBuffer}
            <span
              className="inline-block w-px h-[1.1em] bg-violet-500 ml-0.5 align-middle animate-blink"
              aria-hidden
            />
          </>
        )}
      </div>
    </div>
  )
}
